import { render, staticRenderFns } from "./PendenciesDetail.vue?vue&type=template&id=af5fa65a&scoped=true"
import script from "./PendenciesDetail.vue?vue&type=script&lang=js"
export * from "./PendenciesDetail.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=af5fa65a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5fa65a",
  null
  
)

export default component.exports